export const getYoutubeId = (url: string): string | null => {
	const match = url.match(/[?&]v=([^&]+)/);
	return match ? match[1] : null;
};

export const getVideoThumbnail = (videoId: string): string =>
	`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

export const getVideoUrl = (videoId: string): string =>
	`https://www.youtube.com/embed/${videoId}?autoplay=1&playsinline=1`;

export const getErrorImg = (
	width: number,
	height: number,
	backgroundColor: string,
	color: string,
	text: string
) => `https://placehold.co/${width}x${height}/${backgroundColor}/${color}?text=${text}`;
